export default {
  creditdebit: 1,
  giftcard: 2,
  schoolcash: 3,
  cash: 4,
  applepay: 6,
  creditdebitembedded: 8
};
